// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__X6F3o","buttons":"SendReceipts_buttons__2SR_w","email":"SendReceipts_email__3wBV5","bookApptTitle":"SendReceipts_bookApptTitle__3CwWc"};